import { Bloom } from "./bloom.js";

/** A line of muted text with the mark assembling beside it: "Reading these answers". */
export function InlineLoader({ text }: { readonly text: string }) {
  return (
    <span className="inline-loader" role="status">
      <Bloom size={14} motion="assemble" />
      {text}
    </span>
  );
}

/**
 * A button's label while it works. The mark is painted in the button's own text
 * colour. Both labels share one grid cell, so the button is as wide as the wider
 * of the two and never changes width when it starts or stops working.
 */
export function BusyLabel({
  busy,
  idle,
  working,
}: {
  readonly busy: boolean;
  readonly idle: string;
  readonly working: string;
}) {
  return (
    <span className="busy-label" data-busy={busy}>
      {/* The hidden face is hidden from the accessible name too: the button is
          called what it shows, "Save" or "Saving…", never both. */}
      <span
        className={busy ? "busy-label-face is-hidden" : "busy-label-face"}
        aria-hidden={busy}
      >
        {idle}
      </span>
      <span
        className={busy ? "busy-label-face" : "busy-label-face is-hidden"}
        aria-hidden={!busy}
      >
        <Bloom size={14} motion={busy ? "assemble" : "still"} tone="mono" />
        {working}
      </span>
    </span>
  );
}

/** A page or panel waiting: the mark assembling, one line beneath it. */
export function PageLoader({
  caption,
  size = 64,
}: {
  readonly caption: string;
  readonly size?: number;
}) {
  return (
    <div className="page-loader" role="status" aria-label={caption}>
      <Bloom size={size} motion="assemble" />
      <p className="page-loader-caption">{caption}</p>
    </div>
  );
}

/** A whole screen waiting, before anything of the page itself can draw. */
export function ScreenLoader({ caption }: { readonly caption: string }) {
  return (
    <div className="page page-loading">
      <PageLoader caption={caption} />
    </div>
  );
}
